module.exports = __webpack_public_path__ + "img/icon7.9afb96bf.png";